import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields", "result", "submitButton"]
  static values = { url: String, inboxUrl: String }

  addField() {
    const row = document.createElement("div")
    row.className = "test-field-row grid grid-cols-[minmax(0,1fr)_minmax(0,2fr)_40px] items-start gap-2"
    row.innerHTML = `
      <input type="text" class="test-field-name h-10 rounded-md border border-dashed border-gray-300 bg-white px-3 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="field name">
      <input type="text" class="test-field-value h-10 rounded-md border border-gray-300 bg-white px-3 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="value">
      <button type="button" class="mt-1 inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:bg-rose-50 hover:text-rose-600" title="Remove field" data-action="test-page#removeField">
        <svg class="h-4 w-4 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/></svg>
      </button>`
    this.fieldsTarget.appendChild(row)
    row.querySelector(".test-field-name")?.focus()
  }

  removeField(event) {
    event.target.closest(".test-field-row")?.remove()
  }

  async submit(event) {
    event.preventDefault()

    const formData = new FormData()
    this.fieldsTarget.querySelectorAll(".test-field-row").forEach((row) => {
      const name = row.querySelector(".test-field-name")?.value?.trim()
      const value = row.querySelector(".test-field-value")?.value ?? ""
      if (name) formData.append(`form_data[${name}]`, value)
    })

    this.setLoading(true)
    this.resultTarget.classList.add("hidden")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          "Accept": "application/json"
        },
        body: formData
      })
      const body = await response.json()

      if (response.ok && body.success) {
        this.resultTarget.className = "rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800"
        this.resultTarget.innerHTML = `
          <div class="font-semibold">Submission received</div>
          <p class="mt-1">Created ${body.submission_id} in ${body.elapsed_ms} ms. Notifications are running in the background.</p>
          <div class="mt-3 flex flex-wrap gap-2">
            <a href="${body.submission_url}" class="inline-flex h-8 items-center rounded-md bg-emerald-600 px-3 text-xs font-medium text-white hover:bg-emerald-700">View submission</a>
            <a href="${this.inboxUrlValue}" class="inline-flex h-8 items-center rounded-md border border-emerald-200 bg-white px-3 text-xs font-medium text-emerald-700 hover:bg-emerald-50">Open inbox</a>
          </div>`
      } else {
        this.showError(body.error || `HTTP ${response.status}`)
      }
    } catch (error) {
      this.showError(error.message)
    } finally {
      this.resultTarget.classList.remove("hidden")
      this.setLoading(false)
    }
  }

  showError(message) {
    this.resultTarget.className = "rounded-lg border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800"
    this.resultTarget.textContent = `Failed to send test submission: ${message}`
  }

  setLoading(isLoading) {
    this.submitButtonTarget.disabled = isLoading
    this.submitButtonTarget.textContent = isLoading ? "Sending..." : "Send test submission"
  }
}
